module.exports = {"id":"199290","name":"Arsen Khubulov","rating":"72","photo":"./data/images/photos/3/199290.png","club":{"name":"Anzhi Makhachkala","logo":"./data/images/clubs/AnzhiMakhachkala.png"},"positions":["MD","ATT","MG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ArsenKhubulov0.json
// module id = 474
// module chunks = 0